// extracted by css-extract-rspack-plugin
export default {"title":"title-JpGgVl","forClient":"forClient-TsExdC"};